import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import Animation2 from './components/Animation2';
import Animation3D from './components/Animation3D';
import BannerA from './components/BannerA';
import BannerB from './components/BannerB';
import BlackA from './components/BlackA';
import CompareA from './components/CompareA';
import EarlyBirdOffer from './components/EarlyBirdOffer';
import FaqA from './components/FaqA';
import FooterTcA from './components/FooterTcA';
import ListA1 from './components/ListA1';
import ListA2 from './components/ListA2';
import ListB from './components/ListB';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA3 from './components/SectionA3';
import SectionB from './components/SectionB';
import SectionC from './components/SectionC';
import SectionD from './components/SectionD';
import WhatInBoxA from './components/WhatInBoxA';

export default function AU_Product() {
    const { t } = useLang('theProduct.KSP');
    const { pageStatus } = useProductStore();
    const IS_Status_A = pageStatus === IPageStatus.statusA;
    const IS_Status_B = pageStatus === IPageStatus.statusB;
    return (
        <div className="ecoflow-wave-3-page">
            {IS_Status_A ? <BannerA /> : <BannerB />}
            <EarlyBirdOffer endTime={new Date('2025/09/30 23:59:59 GMT+8').getTime()} />
            <div className="range1">
                <EcoSpace />
                <ListA1 />
                {/* <EcoSpace /> */}
            </div>

            <SectionA3 />
            <ListB />
            <div className="range2">
                <Animation2 />
            </div>
            <div className="range3">
                <SectionB />
            </div>

            <div className="range4">
                <BlackA />
                <ListA2 />
            </div>
            <div className="range5">
                <FaqA />
            </div>
            <div className="range6">
                <SectionD />
            </div>
            <SectionC />
            <Animation3D />
            <CompareA />
            <WhatInBoxA />
            <FooterTcA />
            <PageNavLeft
                triggerElement=".ecoflow-wave-3-page"
                steps={[
                    { text: t('item1'), href: '#ListA1' },
                    { text: t('item2'), href: '#wave3-D' },
                    { text: t('item3'), href: '#SectionB' },
                    { text: t('item4'), href: '#BlackA' },
                    { text: t('item5'), href: '#FaqA' },
                    { text: t('item6'), href: '#SectionD' },
                ]}
                triggerElements={[
                    { selectors: '#SectionB', theme: Theme.black },
                    { selectors: '#range2', theme: Theme.black },
                    { selectors: '#range3', theme: Theme.white },
                    { selectors: '#ListB', theme: Theme.black },
                    { selectors: '#BlackA', theme: Theme.white },
                    { selectors: '#ListA2', theme: Theme.white },
                    { selectors: '#FaqA', theme: Theme.black },
                ]}
            />
        </div>
    );
}
